<template>
  <AtomHorizontalScroll>
    <div class="breadcrumbs">
      <!-- <NuxtLink :to="{ name: 'teams' }">{{ $t('shared.nav.teams') }}</NuxtLink> -->
      <NuxtLink :to="{ name: 'team', params: { team: team.slug }}">{{ team.name }}</NuxtLink>
      <NuxtLink to="#" v-if="!['team', 'team-game'].includes(route.name)">{{ heading }}</NuxtLink>
      
      <!-- Game Center Breadcrumbs -->
      <NuxtLink :to="{ name: 'team-fixtures', params: { team: team.slug }}" v-if="isGame && !isGameFinished">
        {{ $t('shared.nav.fixtures') }}
      </NuxtLink>
      <NuxtLink :to="{ name: 'team-results', params: { team: team.slug }}" v-if="isGame && isGameFinished">
        {{ $t('shared.nav.results') }}
      </NuxtLink>
      <NuxtLink to="#" v-if="isGame">
        {{ game?.name }}
      </NuxtLink>
    </div>
  </AtomHorizontalScroll>
</template>

<script setup>
const { t } = useI18n()
const route = useRoute()
const team = useTeamStore()
const gameSlug = computed(() => route.params?.game)
const game = computed(() => useState(`game:${gameSlug.value}`).value)

const isGame = computed(() => route.name === 'team-game' && game.value?.name)
const isGameFinished = computed(() => game.value?.status === 'finished')

const headingKeyMap = {
  'team-fixtures': 'shared.nav.fixtures',
  'team-results': 'shared.nav.results',
  'team-table': 'shared.nav.table',
  'team-statistics': 'shared.nav.statistics',
}

const heading = computed(() => {
  const key = headingKeyMap[route.name]
  return key ? t(key, { team: team.name }) : ''
})
</script>
